import { render, staticRenderFns } from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=template&id=ad5abbf8&scoped=true&lang=pug"
import script from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=script&lang=ts"
export * from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=script&lang=ts"
import style0 from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=style&index=0&id=ad5abbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5abbf8",
  null
  
)

export default component.exports